export const urlAPI = window._env_.REACT_APP_BACKEND;
// export const wsURL = `${window._env_.REACT_APP_WEBSOCKET}`;
 